export default {
  plan: 'Plano',
  continue: 'Continuar',
  docs: 'Documentação',
  assistViaEmail: 'Teremos prazer em ajudá-lo por e-mail.',
  sendFeedback: 'Envie suas perguntas e feedback para',
  howDoISignUp: 'Como me inscrever',
  requiredName: 'Nome é um campo obrigatório',
  requiredEmail: 'E-mail é um campo obrigatório',
  requiredPassword: 'Senha é um campo obrigatório',
  invalidEmail: 'E-mail não é válido',
  minLengthPassword: 'A senha deve conter 8 letras ou dígitos',
  invalidPassword:
    'A senha deve conter uma letra maiúscula, uma letra minúscula, um número e um caractere especial',
  getStartedWorkoutPlanEmailReminder:
    'Para começar, basta acessar a página Fit4Me e responder a algumas perguntas rápidas sobre suas preferências de treino e nutrição, objetivos e nível geral de forma física. Também solicitaremos seu e-mail: certifique-se de inseri-lo corretamente. Assim que criarmos um plano personalizado para você, forneceremos o link para download do app para que você possa começar imediatamente.',
  howWillIReceiveMyCustomizedMealAndWorkoutPlan:
    'Como receberei meu plano de refeições e treino personalizado',
  appDownloadAndAccessInstructions:
    'Você receberá um link de download exclusivo que o levará à App Store para baixar o app. Após instalar, faça login usando seu e-mail. Você terá acesso ilimitado a todos os recursos do app durante o período pago. Se tiver dificuldades para baixar ou acessar o app, entre em contato conosco em',
  planReceiveTime: 'Quando receberei meu plano de refeições e treino personalizado',
  planGenerationDetails:
    'Nossos algoritmos inteligentes são altamente precisos e capazes de personalizar seu plano de condicionamento de acordo com suas necessidades específicas. O link de download exclusivo será gerado imediatamente após o pagamento. O plano estará disponível assim que você baixar o app com seu link exclusivo.',
  freeTrialQuestion: 'Sempre oferecemos testes gratuitos',
  freeTrialInfo:
    'Observe que, se um teste gratuito for oferecido, isso será explicitamente indicado na tela de preços antes da finalização da compra. Caso contrário, você adquirirá nossa assinatura sem teste gratuito.',
  billingQuestion: 'Como serei cobrado',
  billingInfo:
    'Normalmente oferecemos assinaturas com renovação automática. Dependendo da opção escolhida, sua assinatura será renovada ao final de cada período.',
  cancelSubscriptionQuestion: 'Posso cancelar minha assinatura',
  cancelSubscriptionInfo:
    'Sua assinatura é renovada automaticamente ao final de cada período até que você a cancele. Observe que excluir o app não cancela sua assinatura. Você pode cancelar um teste ou assinatura em Assinaturas no seu iPhone ou por e-mail.',
  noAccessQuestion: 'Não tenho mais acesso à minha assinatura, o que aconteceu',
  noAccessInfo:
    'Às vezes oferecemos assinaturas não renováveis que expiram após o período de assinatura (1 mês, 3 meses ou 6 meses). Após a expiração, você perde o acesso ao app. Se desejar continuar usando o app após a expiração, poderá recomprá-lo no app ou na página do Fit4Me a qualquer momento.',
  loginLabel: 'Faça login com seu e-mail para acessar seu plano pessoal de perda de peso',
  email: 'Email',
  logIn: 'Entrar',
  name: 'Nome',
  gender: {
    label: 'Gênero',
    male: 'masculino',
    female: 'feminino',
  },
  dateOfBirth: 'Data de nascimento',
  units: {
    label: 'Unidades',
    kg: 'kg',
    cm: 'cm',
    lbs: 'lbs',
    in: 'in',
    m: 'm',
    ft: 'ft',
  },
  startWeight: 'Peso inicial',
  height: 'Altura',
  doubleCheckAndRetry: 'Por favor, verifique e tente novamente',
  wrongEmail: 'Ops, email incorreto',
  invalidEmailOrPassword: 'Ops, email ou senha incorretos',
  avatar: 'avatar',
  Profile: 'Perfil',
  Subscriptions: 'Assinaturas',
  loader: 'carregando',
  billingPeriod: 'Período de faturamento',
  subscriptionPrice: 'Preço da assinatura',
  subscriptionCanceled: 'Sua assinatura foi cancelada.',
  noFutureCharges: 'Você não será cobrado no futuro.',
  fullAccessUntilExpires:
    'Você terá acesso total ao Fit4Me até a expiração da sua assinatura atual.',
  opps: 'Ops! <br/>Algo deu errado.',
  contactUsEmail:
    'Entre em contato via <br/><a href="mailto:{{companyEmail}}">{{companyEmail}}</a>',
  ok: 'ok',
  tooExpensive: 'É muito caro',
  planNotSuitable: 'O plano não atende às minhas necessidades',
  appQualityDisappointment: 'A qualidade do app ficou abaixo das minhas expectativas',
  notUsingButMayReturn: 'Não estou usando o app no momento, mas posso voltar mais tarde',
  goalsAchieved: 'Já atingi meus objetivos',
  technicalIssues: 'Houve problemas técnicos',
  planTooChallenging: 'Meu plano é muito desafiador',
  avoidAutoRenewalFee: 'Quero evitar a cobrança automática de renovação',
  forgotPassword: 'Esqueci a senha?',
  resetPassword: 'Redefinir senha',
  labelForgot: 'Digite seu email para redefinir a senha',
  placeholderEmail: 'Digite seu email',
  recoveryEmailSentAt: 'E-mail de recuperação enviado em',
  pleaseCheckYourInbox: 'Por favor, verifique sua caixa de entrada (e spam)',
  sendAgain: 'reenviar',
  changeEmail: 'alterar email',
  checkingYouEmail: 'Verificando seu e-mail',
  agreePrivacyPolicy:
    'Ao continuar, você concorda com nossa <privacy>Política de Privacidade</privacy> e nossos <terms>Termos de Uso</terms>',
  emailLogin: 'Login por e-mail',
  loginToFit4Me: 'Entrar no Fit4Me',
  enter5DigitCode: 'Insira o código de 5 dígitos enviado para o seu e-mail <bold>{{email}}</bold>',
  didNotReceiveTheCode: 'Não recebeu o código?',
  resendCode: 'Reenviar código',
  contactSupport: 'Ou você pode <bold>entrar em contato com nosso suporte</bold>',
  codeResent: 'Código reenviado! Você pode solicitar outro em <bold>{{seconds}}s</bold>',
  emailDoesntMatch: 'O código de login não corresponde',
  reCheck: 'Verifique o código ou solicite um novo.',
  payments: 'Pagamentos',
  manageSubscription: 'Gerenciar assinatura',
  activeBadge: 'Ativo',
  paymentMethod: 'Método de pagamento',
  cancelSubscriptionReason: 'Por que deseja cancelar?',
  nextChargeDate: 'Próxima data de cobrança',
  lastChargeDate: 'Última data de cobrança',
  accessUntil: 'Acesso até',
  renewSubscription: 'Renovar assinatura',
  addPaymentMethod: 'Adicionar método de pagamento',
  noPaymentTitle: 'Nenhum método de pagamento',
  noPaymentDescription: 'Adicione um método de pagamento para iniciar sua assinatura',
  canceledStatus: 'Cancelado',
  yourFeedbackMatters: 'Sua opinião é importante!',
  specialOffer: 'Aguarde enquanto geramos uma oferta especial.',
  limitedDeal: 'Oferta por tempo limitado',
  offerSavings: 'Oferecemos 99% de desconto por 6 semanas',
  keepWellness: 'Continue sua jornada de bem-estar por apenas 1% do custo normal!',
  dontMissChance:
    '{{name}}, não perca a chance de continuar com a orientação nutricional personalizada do Simple. Após o período de economia de 3 meses, a cobrança trimestral padrão (US$ 79,20) será retomada automaticamente.',
  keepPremium: 'Manter Premium',
  cancelSubscriptionBtn: 'Cancelar assinatura',
  footerText:
    'Lembre-se: você pode cancelar a qualquer momento antes de 30 de abril de 2025 sem taxas de renovação. Sua tarifa com 99% de desconto se aplica a todo o período de 12 semanas. Se você optar por continuar, sua assinatura será renovada automaticamente com a tarifa trimestral normal de US$ 79,20 após o término do período promocional. Não fornecemos reembolsos por tempo de assinatura parcialmente utilizado. Para gerenciar ou cancelar sua assinatura, basta visitar sua página de Gerenciamento de Assinatura.',
  prosList: {
    analyzed: 'Perfil analisado',
    noChange: 'Sem alteração no seu ciclo de cobrança atual',
    after: 'Após 12 semanas, sua assinatura será de US$ 79,20 trimestral.',
  },
  gotIt: 'Ok, entendi',
  weCanceled: 'Cancelamos sua assinatura',
  yourSubscriptionIsCanceled:
    'Sua assinatura do Fit4Me foi cancelada. Não haverá mais cobranças. Você ainda terá acesso total até',
  supportForEditional: 'para mais informações',
  contact: 'Entre em contato',
  id: 'ID',
  'My account': 'Minha conta',
  'My Subscriptions': 'Minhas assinaturas',
  Support: 'Suporte',
  FAQ: 'Perguntas frequentes',
  'Cancel Subscription': 'Cancelar assinatura',
  'Money-Back Policy': 'Política de reembolso',
  'Privacy Policy': 'Política de privacidade',
  'Terms of Use': 'Termos de uso',
  'Meals Recommendations': 'Recomendações de refeições',
  'Contact Us': 'Fale conosco',
}
